var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU06 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 308.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-1897.00, 0.00)",
    id: "U6_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1909.79,220.54 C1910.60,215.98 1915.32,195.12 1917.41,187.21 C1919.63,179.58 1924.96,163.46 1927.25,158.31 C1930.27,151.58 1937.93,138.94 1942.57,133.02 C1947.81,126.39 1958.55,116.29 1964.82,111.55 C1971.28,106.69 1985.89,97.80 1994.00,93.80 C2001.93,89.91 2017.63,83.43 2024.65,81.14 C2031.65,78.87 2046.06,75.85 2052.90,75.80 C2057.06,75.80 2064.67,76.74 2068.13,77.68 C2071.61,78.66 2077.17,81.27 2080.58,83.41 C2086.68,87.29 2100.98,98.86 2106.99,104.77 C2112.87,110.58 2138.34,141.04 2149.61,155.41 C2154.61,161.90 2163.90,174.06 2168.19,179.74 C2173.90,187.41 2181.84,199.99 2184.33,204.67 C2186.92,209.59 2189.41,218.78 2191.43,230.15 C2193.33,241.75 2196.73,277.20 2198.17,293.21 C2198.94,302.61 2200.42,322.80 2200.50,330.41 C2200.57,339.14 2199.46,354.78 2198.27,361.70 C2197.15,368.18 2193.17,381.54 2189.13,388.34 C2187.17,391.60 2182.63,397.25 2180.06,399.65 C2177.47,402.03 2171.68,405.92 2168.51,407.42 C2164.09,409.47 2148.23,414.05 2139.13,416.11 C2132.53,417.50 2113.45,420.66 2105.64,421.49 C2093.68,422.60 2057.39,424.25 2039.65,424.39 C2031.06,424.29 2014.88,423.73 2007.29,423.27 C2000.04,422.68 1983.21,420.73 1977.79,419.49 C1972.34,418.22 1962.62,415.32 1958.30,413.68 C1949.99,410.47 1939.88,404.08 1931.57,398.36 C1925.39,393.87 1917.55,387.76 1912.47,381.71 C1910.47,379.30 1906.98,374.23 1906.06,372.30 C1903.66,367.17 1900.95,348.85 1900.90,340.46 C1901.03,327.71 1902.38,295.81 1903.29,278.54 C1904.70,260.97 1908.58,227.41 1909.79,220.54 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU06, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-06.d832d5fd.svg";
export { ForwardRef as ReactComponent };